import React from 'react';
import { differenceInMinutes, format } from 'date-fns';
import { Grid, TextField } from '@material-ui/core';
function isDateValid(date) {
    return !!(date && !isNaN(+new Date(date)));
}
// common validator for EntitySampleDateRangeConfigurator
export const EntitySampleDateRangeValidator = config => {
    const { min, max } = config;
    const minError = !min
        ? 'Min date is required.'
        : !isDateValid(min)
            ? 'Invalid date.'
            : undefined;
    const maxError = !max
        ? 'Max date is required.'
        : !isDateValid(max)
            ? 'Invalid date.'
            : min && max && differenceInMinutes(new Date(max), new Date(min)) < 0
                ? 'Max date is less than the Min date.'
                : undefined;
    return minError || maxError ? { min: minError, max: maxError } : undefined;
};
function getDateValue(d, dateOnly) {
    const df = 'yyyy-MM-dd';
    return d && isDateValid(d)
        ? format(new Date(d), dateOnly ? df : `${df}'T'HH:mm:00`)
        : '';
}
export const EntitySampleDateRangeConfigurator = props => {
    const { column, config, disabled, validate, onChange } = props;
    const dateOnly = column.type === 'date';
    const errors = (validate === null || validate === void 0 ? void 0 : validate(config, column)) || {};
    const renderInput = (type) => {
        const isMin = type === 'min';
        return (React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', disabled: disabled, error: !!errors[type], label: isMin ? 'Min' : 'Max', InputLabelProps: { shrink: true }, type: dateOnly ? 'date' : 'datetime-local', defaultValue: getDateValue(config[type], dateOnly), helperText: errors[type] || `Set the ${isMin ? 'minimum' : 'maximum'} date range`, onChange: event => {
                const { value } = event.target;
                const date = value && getDateValue(new Date(value + 'Z'), dateOnly);
                onChange === null || onChange === void 0 ? void 0 : onChange({ [type]: date || undefined });
            } }));
    };
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12, sm: 6 }, renderInput('min')),
        React.createElement(Grid, { item: true, xs: 12, sm: 6 }, renderInput('max'))));
};
//# sourceMappingURL=EntitySampleDateRangeConfigurator.js.map